import { render, staticRenderFns } from "./Imprint.vue?vue&type=template&id=21d2e556&scoped=true"
import script from "./Imprint.vue?vue&type=script&lang=js"
export * from "./Imprint.vue?vue&type=script&lang=js"
import style0 from "./Imprint.vue?vue&type=style&index=0&id=21d2e556&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d2e556",
  null
  
)

export default component.exports